import { Legend as View } from "ui-components";

import { useCloseMapTool } from "~map-view/states";
export const LegendTool = () => {
	const onClose = useCloseMapTool();

	return (
		<View
			layerGroups={[]}
			onClose={onClose}
		/>
	);
};
